import React from 'react';
import { CommonPrelanderV44 } from '../../components/CommonPrelanderV44';
import { AGE_BRANCH_SLIDES_V34, QUIZ_SLIDES_V34 } from '../../shared/quiz-slides/quiz-slides-v34';

function PrelanderV53Page({ initialPrelander }) {
    return (
        <CommonPrelanderV44
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V34}
            ageBranchSlides={AGE_BRANCH_SLIDES_V34}
        />
    );
}

export {
    PrelanderV53Page
};
